import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../utils/loadable';

const vfDiscountsPage = Loadable(() => import('../containers/index'));
export default MapTo('vcg/components/soe-home/react/vfdiscount')(vfDiscountsPage);
